import React from 'react';

import { Skeleton, Typography } from '@mui/material';

import { SxProp } from '@hrlogics/react-helper-types';

import type { Nullable } from '@clearverify/types';
import { parseNullableValue } from '@clearverify/utils';

import { DemoPrivacyFieldValue } from 'src/components/demoPrivacyMode';
import { InfoBlockContext } from 'src/providers/InfoBlockProvider';

interface InfoBlockItemProps {
  title: React.ReactNode;
  value: Nullable<React.ReactNode>;
  loading?: boolean;
}

export const InfoBlockItem: React.FC<InfoBlockItemProps> = ({ title, value, loading }) => {
  const { loading: loadingFromContext } = React.use(InfoBlockContext);

  return (
    <React.Fragment>
      <Typography variant="body1" color="text.secondary">
        {title}
      </Typography>

      <Typography variant="body1">
        {loadingFromContext || loading ? (
          <Skeleton variant="text" sx={skeletonStyles} />
        ) : typeof value === 'string' || typeof value === 'number' ? (
          <DemoPrivacyFieldValue value={String(value)} />
        ) : (
          parseNullableValue(value)
        )}
      </Typography>
    </React.Fragment>
  );
};

const skeletonStyles: SxProp = {
  fontSize: '1rem',
  width: '50%',
  minWidth: 200,
};
